import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {Panel} from "../../../../framework/model/core/panel/panel";
import {ModelToolsProvider} from "../../../../framework/providers/model-tools/model-tools";
import {AppDataService} from "../../../services/AppDataService";
import {ItemProvider} from "../../../pages/item/providers/item-provider/item-provider.service";
import {MainService} from "../../../services/MainService";
import {OrderService} from "../../../services/OrderService";
import {AppUser} from "../../../../framework/model/core/appuser/appuser";
import {BusinessService} from "../../../services/BusinessService";
import {Events} from "../../../../framework/providers/events";
import {AdminService} from "../../../../app/shaps/services/AdminService";
import {Router, NavigationEnd, ActivatedRoute} from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'app-panel',
    templateUrl: './app-panel.component.html',
    styleUrls: ['./app-panel.component.scss'],
})
export class AppPanelComponent implements OnInit {
    @Input()
    public models: Array<Panel> = [];
    public filteredModels: Array<Panel> = [];

    @Input()
    public filters: object = {'ordering': 'order', 'removed': false, 'active': true};

    @Input()
    public key;

    @Input()
    public appDataKey = 'main-panels';

    public prefix;

    ready = true;
    public appuser: AppUser;

    constructor(public events: Events,
                public router: Router,
                private activatedRoute: ActivatedRoute,
                public orderService: OrderService, public adminService: AdminService, public tools:ModelToolsProvider, public appdata:AppDataService) {
    }

    ngOnInit() {
        this.prefix = this.key+'_panels_'+this.tools.getRandomize()
        this.filters['key'] = this.key;
        this.filters['limit'] = 100;

        this.setAppUser()

        this.events.subscribe('appuserChanged', (res) => {
            this.setAppUser()
            // this.filterData()
        }, this.prefix, 'app-panel');

        this.events.subscribe('appPriceSets', (res) => {
            this.setFilter('group_id', this.appdata.getPricesListKey('group_id'))
        }, this.prefix, 'app-panel');

        this.events.subscribe(this.prefix + '_modelUpdated', (res) => {
            this.models = res['models'];
            this.filterData();
        }, this.prefix, 'app-panel');

        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd)
        ).subscribe(() => {
            this.filterData();
        });

    }

    filterData()
    {
        let models = this.models;
        if(this.filters['type'])
            models = models.filter((x)=> x.data.type == this.filters['type'])

        let panelIds = this.appdata.getPricesListKey('panel_ids')
        if(panelIds)
            models = models.filter((x)=> panelIds.includes(x.data.id));

        let userType = this.appuser ? this.appuser.data.userType : null;
        models = models.filter((x)=> !x.data.options['userType'] || x.data.options['userType'].includes(userType));
        models = this.filterByGroup(models, this.appuser ? this.appuser.data['userGroups'] : ['no_user']);

        // --- New filter by current page ---
        const current_page_name = this.router.url.split('/')[1]?.split('?')[0];
        if (current_page_name) {
            models = models.filter(model => {
                const opts = model.data.options || {};
                // Exclude if include_pages exists and does not include current page
                if (opts['include_pages'] && Array.isArray(opts['include_pages']) && !opts['include_pages'].includes(current_page_name)) {
                    return false;
                }
                // Exclude if exclude_pages exists and includes current page
                if (opts['exclude_pages'] && Array.isArray(opts['exclude_pages']) && opts['exclude_pages'].includes(current_page_name)) {
                    return false;
                }
                return true;
            });
        }

        this.filteredModels = models;
    }

    filterByGroup(models, groupsToFilter: any[]) {
        if(!groupsToFilter) return models
        return models.filter(item => {
            let groups = item.data.options['userGroups'];
            if(!groups) return true
            return groups.some(group => groupsToFilter.includes(group))
        });
    }


    ngOnDestroy()
    {
        this.events.unsubscribe('appuserChanged', this.prefix, 'app-panel');
        this.events.unsubscribe('appPriceSets', this.prefix, 'app-panel');
        this.events.unsubscribe(this.prefix + '_modelUpdated',  this.prefix, 'app-panel');
    }

    setAppUser()
    {
        this.appuser = this.orderService.getAppUser();
        // this.setFilter('group_id', this.appdata.getPricesListKey('group_id'))
    }

    setFilter(key, value)
    {
        this.filters[key] = value;
        this.events.publish(this.prefix + '_updateFilter', this.filters)
    }

    refresh() {
        let me = this;
        this.ready = false;
        setTimeout(function () {
            me.ready = true;
        })
    }
}
